import * as type from '../mutation-types'
// const R = require('ramda')

export const saisonStore = {
  namespaced: true,
  state: {
    /* API URLS */
    apiUrls: {
      getCurrentMatchDay: 'saison/getCurrentMatchDay',
      loadSpieltag: 'saison/loadSpieltag',
      loadLogos: 'users/getLogos',
      loadLeagues: 'saison/loadLeagues'
    },
    saison: {
      name: '',
      nr: 0,
      spieltag: 1
    },
    modalOpen: false,
    selectedLiga: {},
    spieltage: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22],
    lastGameDay: {},
    logos: [],
    cache: [],
    tabelle: {},
    statistik: {},
    ligaStatistik: {},
    ligen: {
      120: [],
      200: []
    },
    logoCacheTime: 0, // in sec
    leagueCacheTime: 0 // in sec
  },
  mutations: {
    [type.SAISON_RESET] (state) {
      state.saison = {
        name: '',
        nr: 0,
        spieltag: 0
      }
      state.logoCacheTime = 0
      state.leagueCacheTime = 0
      state.cache = []
      state.logos = []
      state.selectedLiga = {}
      state.lastGameDay = {}
      state.tabelle = {}
      state.statistik = {}
      state.ligaStatistik = {}
      state.ligen = {
        120: [],
        200: []
      }
    },
    [type.SAISON_SET_SAISON] (state, loadedData) {
      state.saison.name = loadedData.name
      state.saison.nr = loadedData.nr
      if (loadedData.spieltag) {
        state.saison.spieltag = loadedData.spieltag
      }
    },
    [type.SAISON_SET_MODAL_OPEN] (state, val) {
      state.modalOpen = val
    },
    [type.SAISON_SET_LOGOS] (state, logos) {
      state.logos = logos || []
    },
    [type.SAISON_SET_NEW_TEAM_LOGO] (state, user) {
      state.logos[user.id] = user.teamLogo
    },
    [type.SAISON_SET_LOGO_CACHE_TIME] (state) {
      state.logoCacheTime = Math.floor(new Date().getTime() / 1000)
    },
    [type.SAISON_SET_LEAGUE_CACHE_TIME] (state) {
      state.leagueCacheTime = Math.floor(new Date().getTime() / 1000)
    },
    [type.SAISON_SET_CACHE] (state, cacheData) {
      const dataObj = {
        auswertung: cacheData.auswertung,
        tabelle: cacheData.tabelle,
        statistik: cacheData.statistik,
        ligaStatistik: cacheData.ligaStatistik,
        liga: cacheData.liga
      }
      if (!state.cache[cacheData.ligaId]) {
        state.cache[cacheData.ligaId] = { spieltag: {} }
        state.cache[cacheData.ligaId].spieltag[cacheData.spieltag] = dataObj
      } else {
        state.cache[cacheData.ligaId].spieltag[cacheData.spieltag] = dataObj
      }
    },
    [type.SAISON_SET_LIGEN] (state, ligen) {
      state.ligen = ligen
    },
    [type.SAISON_SET_LIGA] (state, liga) {
      state.selectedLiga = liga
    },
    [type.SAISON_SET_AUSWERTUNG] (state, data) {
      state.lastGameDay = data.lastGameDay
      state.tabelle = data.tabelle

      if (data.statistik) {
        state.statistik = data.statistik
      } else {
        state.statistik = {
          heimBestleistung: {
            user: { id: 0 },
            einzel: {
              user: {
                id: 0
              },
              saison: {
                spieltag: 0
              }
            },
            saison: {
              spieltag: 0
            }
          },
          auswBestleistung: {
            user: { id: 0 },
            einzel: {
              user: {
                id: 0
              },
              saison: {
                spieltag: 0
              },
              ergebnis: 0
            },
            saison: {
              spieltag: 0
            },
            ergebnis: 0
          }
        }
      }

      if (!state.statistik.heimBestleistung) {
        state.statistik.heimBestleistung = {
          user: { id: 0 },
          einzel: {
            user: {
              id: 0
            },
            saison: {
              spieltag: 0
            }
          },
          saison: {
            spieltag: 0
          }
        }
      }
      if (!state.statistik.heimBestleistung.einzel) {
        state.statistik.heimBestleistung.einzel = {
          user: {
            id: 0
          },
          saison: {
            spieltag: 0
          }
        }
      }
      if (!state.statistik.auswBestleistung) {
        state.statistik.auswBestleistung = {
          user: { id: 0 },
          einzel: {
            user: {
              id: 0
            },
            saison: {
              spieltag: 0
            },
            ergebnis: 0
          },
          saison: {
            spieltag: 0
          },
          ergebnis: 0
        }
      }
      if (!state.statistik.auswBestleistung.einzel) {
        state.statistik.auswBestleistung.einzel = {
          user: {
            id: 0
          },
          saison: {
            spieltag: 0
          },
          ergebnis: 0
        }
      }

      if (data.ligaStatistik) {
        state.ligaStatistik = data.ligaStatistik
      } else {
        state.ligaStatistik = {
          heimBestleistung: {
            user: { id: 0 },
            einzel: {
              user: {
                id: 0
              },
              saison: {
                spieltag: 0
              }
            },
            saison: {
              spieltag: 0
            }
          },
          auswBestleistung: {
            user: { id: 0 },
            einzel: {
              user: {
                id: 0
              },
              saison: {
                spieltag: 0
              },
              ergebnis: 0
            },
            saison: {
              spieltag: 0
            },
            ergebnis: 0
          }
        }
      }

      if (!state.ligaStatistik.heimBestleistung) {
        state.ligaStatistik.heimBestleistung = {
          user: { id: 0 },
          einzel: {
            user: {
              id: 0
            },
            saison: {
              spieltag: 0
            }
          },
          saison: {
            spieltag: 0
          }
        }
      }
      if (!state.ligaStatistik.heimBestleistung.einzel) {
        state.ligaStatistik.heimBestleistung.einzel = {
          user: {
            id: 0
          },
          saison: {
            spieltag: 0
          }
        }
      }
      if (!state.ligaStatistik.auswBestleistung) {
        state.ligaStatistik.auswBestleistung = {
          user: { id: 0 },
          einzel: {
            user: {
              id: 0
            },
            saison: {
              spieltag: 0
            },
            ergebnis: 0
          },
          saison: {
            spieltag: 0
          },
          ergebnis: 0
        }
      }
      if (!state.ligaStatistik.auswBestleistung.einzel) {
        state.ligaStatistik.auswBestleistung.einzel = {
          user: {
            id: 0
          },
          saison: {
            spieltag: 0
          },
          ergebnis: 0
        }
      }
    }
  },
  getters: {
    loadCurrentMatchdayUrl: (state, getters, rootState) => {
      return rootState.apiUrls.domain + state.apiUrls.getCurrentMatchDay
    },
    loadSpieltagUrl: (state, getters, rootState) => {
      return rootState.apiUrls.domain + state.apiUrls.loadSpieltag
    },
    getLogosUrl: (state, getters, rootState) => {
      return rootState.apiUrls.domain + state.apiUrls.loadLogos
    },
    getLeagueUrl: (state, getters, rootState) => {
      return rootState.apiUrls.domain + state.apiUrls.loadLeagues
    },
    getLogo: (state) => (teamId) => {
      const item = state.logos.find(logo => logo.id === teamId)
      if (!item) {
        return false
      }
      return item.logo
    }
  },
  actions: {
    // load Spieltag
    async loadSpieltag ({ state, commit, getters, dispatch, rootState }, filterData) {
      // check state
      if (state.cache[filterData.ligaId]) {
        if (state.cache[filterData.ligaId].spieltag && state.cache[filterData.ligaId].spieltag[filterData.spieltag] &&
          state.cache[filterData.ligaId].spieltag[filterData.spieltag].auswertung &&
          state.cache[filterData.ligaId].spieltag[filterData.spieltag].tabelle &&
          state.cache[filterData.ligaId].spieltag[filterData.spieltag].statistik &&
          state.cache[filterData.ligaId].spieltag[filterData.spieltag].ligaStatistik &&
          state.cache[filterData.ligaId].spieltag[filterData.spieltag].liga) {
          // set auswertung
          commit(type.SAISON_SET_AUSWERTUNG, {
            lastGameDay: state.cache[filterData.ligaId].spieltag[filterData.spieltag].auswertung,
            tabelle: state.cache[filterData.ligaId].spieltag[filterData.spieltag].tabelle,
            statistik: state.cache[filterData.ligaId].spieltag[filterData.spieltag].statistik,
            ligaStatistik: state.cache[filterData.ligaId].spieltag[filterData.spieltag].ligaStatistik
          })

          commit(type.SAISON_SET_LIGA, state.cache[filterData.ligaId].spieltag[filterData.spieltag].liga)
          return true
        }
      }

      // set transport options
      const transportOptions = {
        url: getters.loadSpieltagUrl,
        data: filterData
      }
      // send data
      const response = await dispatch('sendDataToServer', transportOptions, { root: true })
      let ret = true
      if (response.success) {
        // set liganame and wurfzahl
        commit(type.SAISON_SET_LIGA, response.data.liga)
        // set auswertung
        commit(type.SAISON_SET_AUSWERTUNG, {
          lastGameDay: response.data.lastGameDay,
          tabelle: response.data.tabelle,
          statistik: response.data.statistik,
          ligaStatistik: response.data.ligaStatistik
        })

        const cacheData = {
          spieltag: filterData.spieltag,
          ligaId: filterData.ligaId,
          auswertung: response.data.lastGameDay,
          tabelle: response.data.tabelle,
          statistik: response.data.statistik,
          ligaStatistik: response.data.ligaStatistik,
          liga: response.data.liga
        }
        commit(type.SAISON_SET_CACHE, cacheData)
      } else {
        ret = false
      }
      return ret
    },
    // load all UserLogos
    async loadAllLogos ({ state, commit, getters, dispatch, rootState }, filterData) {
      const currentTime = Math.floor(new Date().getTime() / 1000) // in sec

      if (state.logos.length > 0 && currentTime < (state.logoCacheTime + rootState.cacheTimeout)) {
        return true
      }

      // set transport options
      const transportOptions = {
        url: getters.getLogosUrl,
        data: { fakeData: true },
        hideLoading: true
      }
      // send data
      const response = await dispatch('sendDataToServer', transportOptions, { root: true })

      let ret = true
      if (response.success) {
        // set liganame and wurfzahl
        commit(type.SAISON_SET_LOGOS, response.data.logos)
        commit(type.SAISON_SET_LOGO_CACHE_TIME)
      } else {
        ret = false
      }

      return ret
    },
    // load all Leagues
    async loadAllLeagues ({ state, commit, getters, dispatch, rootState }, filterData) {
      const currentTime = Math.floor(new Date().getTime() / 1000) // in sec

      if (state.logos.length > 0 && currentTime < (state.leagueCacheTime + rootState.cacheTimeout)) {
        return true
      }

      // set transport options
      const transportOptions = {
        url: getters.getLeagueUrl,
        data: { fakeData: true },
        hideLoading: true
      }
      // send data
      const response = await dispatch('sendDataToServer', transportOptions, { root: true })

      let ret = true
      if (response.success) {
        // set ligennamen
        commit(type.SAISON_SET_LIGEN, response.data.ligen)
        commit(type.SAISON_SET_LEAGUE_CACHE_TIME)
      } else {
        ret = false
      }

      return ret
    }
  }
}
